import React, { Fragment, useEffect, useState } from 'react'
import { Dropdown, DropdownButton, SplitButton, ButtonGroup } from 'react-bootstrap'
import ImageViewer from "react-simple-image-viewer";
import { Form } from 'react-bootstrap'
import avatar1 from '../../../images/avatar/1.jpg'
import Popup from 'reactjs-popup';
import { Link, useLocation, useHistory } from 'react-router-dom'
import { save } from 'save-file'
import * as constants from '../../../utils/Constants'
import { CircularProgress, LinearProgress } from '@mui/material';
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Box from '@mui/material/Box';

const AgentProfile = () => {
    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [items, setItems] = useState([]);
    const history = useHistory();
    const [progress, setProgress] = useState('')
    const [sharePercent, setSharePercent] = useState(0)
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [isPercentOpen, setIsPercentOpen] = useState(false)
    const [progressList, setProgressList] = useState([])
    const loggedInUser = JSON.parse(localStorage.getItem('user'))
    const [agreement, setAgreement] = useState()
    const [isSpin, setIsSpin] = useState(false)
    const url = `${constants.GetRecruitingAgentByIdUrl}/${loggedInUser.userId}`
    const [state, setState] = useState(useLocation().state)
    const { filterDataCallback, searchCallBack, sortByCallBack, orderCallBack, pageCallBack } = useLocation();
    const [acceptPercent, setAcceptPercent] = useState(0)
    const [currentImage, setCurrentImage] = useState(0);
    const [isViewerOpen, setIsViewerOpen] = useState(false);
    const [images, setImages] = useState([]);
    const [profileImage, setProfileImage] = useState(undefined)
    const [agreementUrl, setAgreementUrl] = useState('')

    useEffect(() => {
        if (loggedInUser.roles === 'Recruitment Agent') {
            fetch(url, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${loggedInUser.sessionToken}`,
                },
            })
                .then(response => response.json())
                .then(res => {
                    // console.log("res: ", res.data)
                    setState(res.data)
                })
        }
        fetch(`${constants.AgentViewProfileUrl}/${state.profileImageFileName}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${loggedInUser.sessionToken}`,
            },
        })
            .then(res => res.blob())
            .then(response => {
                setProfileImage(URL.createObjectURL(response))
            })
        // fetch(`${constants.DownloadAgreementUrl}/${state.agreementFileName}`, {
        //     method: 'GET',
        //     headers: {
        //         'Accept': 'application/json',
        //         'Content-Type': 'application/json',
        //         'Authorization': `Bearer ${loggedInUser.sessionToken}`,
        //     },
        // })
        //     .then(res => res.blob())
        //     .then(response => {
        //         setAgreementUrl(URL.createObjectURL(response))
        //     })
        window.scrollTo(0, 0)
        setAgreementUrl(`${constants.DownloadAgreementUrl}/${state?.agreementFileName}`)
    }, [])
    const contentStyle = {
        maxWidth: "600px",
        width: "90%"
    };
    const handleApproved = () => {
        setIsPercentOpen(false)
        fetch(`${constants.ApproveOrRejectAgentUrl}/${state.agentId}`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${loggedInUser.sessionToken}`,
            },
            body: JSON.stringify({ "percentageOfAgent": sharePercent, "agentStatus": "Approved" })
        })
            .then(response => {
                response.json()
            })
            .then(res => {
                setProgress("Approved")
                history.push({
                    pathname: '/list-recruiting-agent',
                })
            })
    }
    const handleViewCheque = (cancelChequeFileName) => {
        if (cancelChequeFileName) {
            var url = `${constants.DownloadChequeUrl}/${state.cancelChequeFileName}`;
            fetch(url, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${loggedInUser.sessionToken}`,
                    Schema: constants.Schema,
                },
            })
                .then(res => res.blob())
                .then(response => {
                    setImages([URL.createObjectURL(response)])
                    setCurrentImage(0);
                    setIsViewerOpen(true);
                })
        }
    }
    const handleViewAadhar = (aadhaarFileName) => {
        if (aadhaarFileName) {
            var url = `${constants.DownloadAadharUrl}/${state.aadhaarFileName}`;
            fetch(url, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${loggedInUser.sessionToken}`,
                    Schema: constants.Schema,
                },
            })
                .then(res => res.blob())
                .then(response => {
                    setImages([URL.createObjectURL(response)])
                    setCurrentImage(0);
                    setIsViewerOpen(true);
                })
        }
    }
    const handleViewPan = (panCardFileName) => {
        if (panCardFileName) {
            var url = `${constants.DownloadPanUrl}/${state.panCardFileName}`;
            fetch(url, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${loggedInUser.sessionToken}`,
                    Schema: constants.Schema,
                },
            })
                .then(res => res.blob())
                .then(response => {
                    setImages([URL.createObjectURL(response)])
                    setCurrentImage(0);
                    setIsViewerOpen(true);
                })
        }
    }
    const sendWelcomeMail = () => {
        setIsSpin(true)
        const url = `${constants.SendWelcomeMailUrl}/${state?.emailId}`
        fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${loggedInUser.sessionToken}`,
                Schema: constants.Schema,
            }})
        setTimeout(() => {
            setIsSpin(false)
            setIsModalOpen(false)
            history.push('/list-recruiting-agent')
        }, 7000);
    }
    const sendReuploadMail = () => {
        setIsSpin(true)
        const url = `${constants.SendReuploadMailUrl}/${state?.agentId}`
        fetch(url, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${loggedInUser.sessionToken}`,
            }
        })
        setTimeout(() => {
            setIsSpin(false)
            setIsModalOpen(false)
            history.push('/list-recruiting-agent')
        }, 7000);
    }
    const handleDownloadAgreement = () => {
        if (state?.agreementFileName) {
            var url = `${constants.DownloadAgreementUrl}/${state.agreementFileName}`;
            // window.location.href = url;
            fetch(url, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${loggedInUser.sessionToken}`,
                    Schema: constants.Schema,
                },
            })
                .then(res => res.blob())
                .then(response => {
                    var fileDownload = require('js-file-download');
                    fileDownload(response, `${state?.agreementFileName}`);
                })
        }
    }
    const handleViewAgreement = () => {
        if (state?.agreementFileName) {
            var url = `${constants.DownloadAgreementUrl}/${state.agreementFileName}`;
            // window.location.href = url;
            fetch(url, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${loggedInUser.sessionToken}`,
                    Schema: constants.Schema,
                },
            })
                .then(res => res.blob())
                .then(response => {
                    const file = new Blob(
                        [response],
                        { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                })
        }
    }
    const closeImageViewer = () => {
        setCurrentImage(0);
        setIsViewerOpen(false);
    };
    const handleDownloadCheque = (cancelChequeFileName) => {
        if (cancelChequeFileName) {
            var url = `${constants.DownloadChequeUrl}/${state?.cancelChequeFileName}`;
            // window.location.href = url;
            fetch(url, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${loggedInUser.sessionToken}`,
                    Schema: constants.Schema,
                },
            })
                .then(res => res.blob())
                .then(response => {
                    var fileDownload = require('js-file-download');
                    fileDownload(response, `${state?.cancelChequeFileName}`);
                })
        }
    }
    const handleDownloadAadhar = (aadhaarFileName) => {
        if (aadhaarFileName) {
            var url = `${constants.DownloadAadharUrl}/${state.aadhaarFileName}`;
            // window.location.href = url;
            fetch(url, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${loggedInUser.sessionToken}`,
                    Schema: constants.Schema,
                },
            })
                .then(res => res.blob())
                .then(response => {
                    var fileDownload = require('js-file-download');
                    fileDownload(response, `${state?.aadhaarFileName}`);
                })
        }
    }
    const handleDownloadPan = (panCardFileName) => {
        if (panCardFileName) {
            var url = `${constants.DownloadPanUrl}/${state.panCardFileName}`;
            // window.location.href = url;
            fetch(url, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${loggedInUser.sessionToken}`,
                    Schema: constants.Schema,
                },
            })
                .then(res => res.blob())
                .then(response => {
                    var fileDownload = require('js-file-download');
                    fileDownload(response, `${state?.panCardFileName}`);
                })
        }
    }
    const handleProgress = (key, event) => {
        let approval = '';
        fetch(`${constants.ApproveOrRejectAgentUrl}/${state.agentId}`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${loggedInUser.sessionToken}`,
            },
            body: JSON.stringify({ "agentStatus": key })
        })
            .then(response => response.json())
            .then(res => {
                approval = res;
            })

        if (approval.error) {
            setIsPercentOpen(false)
        }
        else {
            setProgress(key);
            state.agentStatus = key
        }

    }
    const backBtn = () => {
        history.push({ pathname: "/list-recruiting-agent", state: "", filterDataCallback: filterDataCallback, searchCallBack: searchCallBack, sortByCallBack: sortByCallBack, orderCallBack: orderCallBack, pageCallBack: pageCallBack });
    }
    return (
        <Fragment>
            {loggedInUser.roles === 'Admin' &&
                <div className='form-group'>
                    <button id="go-back" color="primary" className='btn btn-primary' style={{ backgroundColor: '#00ADEE', border: 'none', marginTop: 0, marginBottom: 0, paddingLeft: '10px', paddingRight: '10px', paddingTop: '4px', paddingBottom: '4px' }} type='button'
                        onClick={() => backBtn()}
                    ><i class='fa fa-arrow-circle-o-left' style={{ fontSize: '25px' }} /></button>
                </div>
            }
            <div className='row'>
                <div className='col-xl-5 col-xxl-5'>
                    <div className='row'>
                        <div className='col-xl-12 col-lg-6'>
                            <div className='card  flex-lg-column flex-md-row '>
                                <div className='card-body card-body  text-center border-bottom profile-bx'>
                                    <div className='profile-image mb-4'>
                                        <img src={profileImage} height='118px' width='118px' className='rounded-circle' alt />
                                    </div>
                                    <p className='fs-22 text-black mb-1'>{state?.agentName}</p>
                                    {loggedInUser.agentStatus === 'Unverified' &&
                                        <button className='btn btn-primary btn-md' type='button'>Waiting for Admin's Approval</button>
                                    }
                                </div>
                                <div className='card-body  border-left'>
                                    <div className='d-flex mb-3 align-items-center'>
                                        <a className='contact-icon mr-3' href='#'>
                                            <i className='fa fa-phone' aria-hidden='true' />
                                        </a>
                                        <span className='text-black'>{state?.mobileNumber}</span>
                                    </div>
                                    <div className='d-flex mb-3 align-items-center'>
                                        <a className='contact-icon mr-3' href='#'>
                                            <i className='las la-envelope' />
                                        </a>
                                        <span className='text-black'>{state?.emailId}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-xl-7 col-xxl-7'>
                    <div className='row'>
                        <div className='col-xl-12'>
                            <div className='card profile-card'>
                                <div className='card-header flex-wrap border-0 pb-0'>
                                    <h3 className='fs-24 text-black font-w600 mr-auto mb-2 pr-3'>
                                        {state?.agentName}{'\'s Profile'}
                                        <br />
                                        <Box sx={{ width: '100%' }}>
                                            <LinearProgress variant="determinate" value={state?.profilePercentageCount} />
                                        </Box>
                                        {state?.profilePercentageCount}% completed
                                    </h3>
                                    <div className="form-group row">
                                        <div className="form control" >
                                            <Link className='btn btn-primary btn-md'
                                                style={{ backgroundColor: '#00ADEE', textAlign: 'center', border: 'none' }}
                                                to={{
                                                    pathname: "/edit-agent-profile",
                                                    state: state
                                                }}
                                            >
                                                <i className='fa fa-edit mr-2' />
                                                Complete Profile
                                            </Link>&nbsp;
                                            {(loggedInUser.roles === 'Admin' && state?.aadhaarFileName) &&

                                                < DropdownButton
                                                    className='btn btn-md'
                                                    id="dropdown-basic-button"
                                                    variant='danger'
                                                    title={progress || state.agentStatus || "Action needed"}
                                                >
                                                    {(state?.agentStatus !== "Approved" && state?.agentStatus !== "Accepted") &&
                                                        <div>
                                                            < Dropdown.Item
                                                                eventKey="Approved"
                                                                onSelect={() => {
                                                                    setIsPercentOpen(true)
                                                                    // setProgress("Approved");
                                                                }}
                                                                data-bs-toggle="modal"
                                                                data-bs-target="#staticBackdrop"
                                                            >
                                                                Approve
                                                            </Dropdown.Item>
                                                            <Popup
                                                                open={isPercentOpen}
                                                                onClose={() => { setIsPercentOpen(false) }}
                                                                position="top center"
                                                                closeOnDocumentClick
                                                                modal
                                                                contentStyle={contentStyle}>
                                                                <div className='col-xl-12 col-lg-12'>
                                                                    <div className='card flex-lg-column flex-md-row '>
                                                                        <div className='card-body card-body  text-center border-bottom profile-bx'>
                                                                            <h2 className='col-form-label Description-Label'>Enter % of share</h2>
                                                                            <hr />
                                                                            <div className='form-group row'>
                                                                                <label className='col-lg-4 col-form-label Description-Label'>
                                                                                    Enter % of share
                                                                                    <span className="text-danger">*</span>
                                                                                </label>
                                                                                <div className="col-lg-4">
                                                                                    <input
                                                                                        type='number'
                                                                                        className='form-control Color-box'
                                                                                        placeholder='% of share'
                                                                                        name='sharePercent'
                                                                                        onChange={(e) => setSharePercent(e.target.value)}
                                                                                    >
                                                                                    </input>
                                                                                </div>
                                                                            </div>
                                                                            <div className='text-center mt-4'>
                                                                                <button style={{ border: 'none', backgroundColor: '#00ADEE', textAlign: 'center' }}
                                                                                    type="button"
                                                                                    className="btn btn-primary btn-md"
                                                                                    onClick={handleApproved}
                                                                                >
                                                                                    Approve
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </Popup>
                                                        </div>
                                                    }
                                                    <Dropdown.Item eventKey="Rejected"
                                                        onSelect={handleProgress}>
                                                        Reject
                                                    </Dropdown.Item>
                                                </DropdownButton>
                                            }
                                            {(loggedInUser.roles === 'Admin' && !state?.aadhaarFileName) &&
                                                < DropdownButton
                                                    className='btn btn-md'
                                                    id="dropdown-basic-button"
                                                    variant='danger'
                                                    title={progress || state.agentStatus || "Upload Aadhaar"}
                                                >
                                                    <Dropdown.Item eventKey="Rejected"
                                                        onSelect={handleProgress}>
                                                        Reject
                                                    </Dropdown.Item>
                                                </DropdownButton>
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className='card-body'>
                                    <form>
                                        <div className='mb-sm-5 mb-2'>
                                            <div className='title mb-4'>
                                                <span className='fs-18 text-black font-w600'>
                                                    Information
                                                </span>
                                            </div>
                                            <div className='col-xl-12 col-lg-12'>
                                                <div className='card overflow-hidden'>
                                                    <ul className='list-group list-group-flush'>
                                                        {isViewerOpen && (
                                                            <ImageViewer
                                                                width={200}
                                                                src={images}
                                                                currentIndex={currentImage}
                                                                onClose={closeImageViewer}
                                                                disableScroll={false}
                                                                backgroundStyle={{
                                                                    backgroundColor: "rgba(0,0,0,0.9)"
                                                                }}
                                                                closeOnClickOutside={true}
                                                            />
                                                        )}
                                                        <li className='list-group-item d-flex justify-content-between'>
                                                            <span className='mb-0'>Aadhar Card</span>{' '}
                                                            <strong className='text-black'>{state?.aadharCard} </strong>
                                                        </li>
                                                        <li className='list-group-item d-flex justify-content-between'>
                                                            <span className='mb-0'>Pan Card</span>{' '}
                                                            <strong className='text-black'>{state?.panCard} </strong>
                                                        </li>
                                                        <li className='list-group-item d-flex justify-content-between'>
                                                            <span className='mb-0'>State</span>{' '}
                                                            <strong className='text-black'>{state?.state} </strong>
                                                        </li>
                                                        <li className='list-group-item d-flex justify-content-between'>
                                                            <span className='mb-0'>Commission Sharing</span>{' '}
                                                            <strong className='text-black'>{state?.percentageOfAgent}% </strong>
                                                        </li>
                                                        <li className='list-group-item d-flex justify-content-between'>
                                                            <span className='mb-0'>Qualification</span>{' '}
                                                            <strong className='text-black'>{state?.qualification} </strong>
                                                        </li>

                                                        <li className='list-group-item d-flex justify-content-between'>
                                                            <span className='mb-0'>Experience</span>{' '}
                                                            <strong className='text-black'>{state?.experience} </strong>
                                                        </li>
                                                        <li className='list-group-item d-flex justify-content-between'>
                                                            <span className='mb-0'>Company Name</span>{' '}
                                                            <strong className='text-black'>{state?.companyName} </strong>
                                                        </li>
                                                        <br></br>
                                                        <h4><b>Bank Detail's (Optional)</b></h4>
                                                        <li className='list-group-item d-flex justify-content-between'>
                                                            <span className='mb-0'>Account Number</span>{' '}
                                                            <strong className='text-black'>{state?.accountNumber} </strong>
                                                        </li>
                                                        <li className='list-group-item d-flex justify-content-between'>
                                                            <span className='mb-0'>Account Holder Name</span>{' '}
                                                            <strong className='text-black'>{state?.accountHolderName} </strong>
                                                        </li>
                                                        <li className='list-group-item d-flex justify-content-between'>
                                                            <span className='mb-0'>IFSC code</span>{' '}
                                                            <strong className='text-black'>{state?.ifscCode} </strong>
                                                        </li>
                                                        <li className='list-group-item d-flex justify-content-between'>
                                                            <span className='mb-0'>Bank Name</span>{' '}
                                                            <strong className='text-black'>{state?.bankName} </strong>
                                                        </li>
                                                        <li className='list-group-item d-flex justify-content-between'>
                                                            <span className='mb-0'>Branch name</span>{' '}
                                                            <strong className='text-black'>{state?.branchName} </strong>
                                                        </li>
                                                        <li className='list-group-item d-flex justify-content-between'>
                                                            <span className='mb-0'>GST(if applicable)</span>{' '}
                                                            <strong className='text-black'>{state?.gst} </strong>
                                                        </li>
                                                        <li className='list-group-item d-flex justify-content-between'>
                                                            <span className='mb-0'>Cancel Cheque image</span>{' '}
                                                            {/* <strong className='text-black'>{state.cancelcheque} </strong> */}
                                                            <div>
                                                                <button style={{ border: 'none', backgroundColor: '#00ADEE', textAlign: 'center' }}
                                                                    type="button"
                                                                    className="btn btn-primary btn-md"
                                                                    onClick={() => handleDownloadCheque(state?.cancelChequeFileName)}
                                                                >Download
                                                                </button>&nbsp;
                                                                <button type="button" className="btn btn-primary btn-md" onClick={() => handleViewCheque(state?.cancelChequeFileName)}>
                                                                    View
                                                                </button>
                                                            </div>
                                                        </li>
                                                        <li className='list-group-item d-flex justify-content-between'>
                                                            <span className='mb-0'>Aadhar Card</span>{' '}
                                                            <div>
                                                                <button style={{ border: 'none', backgroundColor: '#00ADEE', textAlign: 'center' }}
                                                                    type="button"
                                                                    className="btn btn-primary btn-md"
                                                                    onClick={() => handleDownloadAadhar(state?.aadhaarFileName)}
                                                                >Download
                                                                </button>&nbsp;
                                                                <button type="button" className="btn btn-primary btn-md" onClick={() => handleViewAadhar(state?.aadhaarFileName)} >
                                                                    View
                                                                </button>
                                                            </div>
                                                        </li>
                                                        <li className='list-group-item d-flex justify-content-between'>
                                                            <span className='mb-0'>Pan Card</span>{' '}
                                                            <div>
                                                                <button style={{ border: 'none', backgroundColor: '#00ADEE', textAlign: 'center' }}
                                                                    type="button"
                                                                    className="btn btn-primary btn-md"
                                                                    onClick={() => handleDownloadPan(state?.panCardFileName)}
                                                                >Download
                                                                </button>&nbsp;
                                                                <button type="button" className="btn btn-primary btn-md" onClick={() => handleViewPan(state?.panCardFileName)} >
                                                                    View
                                                                </button>
                                                            </div>
                                                        </li>

                                                        <li className='list-group-item d-flex justify-content-between'>
                                                            <span className='mb-0'>Agreement</span>{' '}
                                                            <div>
                                                                <button style={{ border: 'none', backgroundColor: '#00ADEE', textAlign: 'center' }}
                                                                    type="button"
                                                                    className="btn btn-primary btn-md"
                                                                    onClick={() => handleDownloadAgreement(state?.agreement)}
                                                                >Download
                                                                </button>&nbsp;
                                                                <button type="button" className="btn btn-primary btn-md"
                                                                    // onClick={handleViewAgreement}
                                                                    onClick={() => {
                                                                        setIsModalOpen(true)
                                                                    }}
                                                                >
                                                                    View
                                                                </button>
                                                                <Popup
                                                                    open={isModalOpen}
                                                                    onClose={() => { setIsModalOpen(false) }}
                                                                    position="top center"
                                                                    closeOnDocumentClick
                                                                    modal
                                                                    isOpen={isModalOpen}
                                                                    contentStyle={contentStyle}>
                                                                    <iframe
                                                                        src={`https://docs.google.com/gview?url=${agreementUrl}&embedded=true`}
                                                                        width='100%' height='500px'
                                                                    ></iframe>
                                                                    {(loggedInUser.roles === 'Admin' && state?.agentStatus !== "Accepted") &&
                                                                        <div className='text-center mt-4'>
                                                                            {
                                                                                isSpin ?
                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn btn-primary btn-md">
                                                                                        <CircularProgress
                                                                                            color='inherit' size={24}
                                                                                            sx={{
                                                                                                color: 'green'
                                                                                            }} />
                                                                                    </button>
                                                                                    :
                                                                                    <button style={{ border: 'none', backgroundColor: '#00ADEE', textAlign: 'center' }}
                                                                                        type="button"
                                                                                        className="btn btn-primary btn-md"
                                                                                        onClick={sendWelcomeMail}
                                                                                    >
                                                                                        Accept
                                                                                    </button>
                                                                            }&nbsp;&nbsp;
                                                                            {
                                                                                isSpin ?
                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn btn-primary btn-md">
                                                                                        <CircularProgress
                                                                                            color='inherit' size={24}
                                                                                            sx={{
                                                                                                color: 'green'
                                                                                            }} />
                                                                                    </button>
                                                                                    :
                                                                                    <button style={{ border: 'none', backgroundColor: '#00ADEE', textAlign: 'center' }}
                                                                                        type="button"
                                                                                        className="btn btn-primary btn-md"
                                                                                        onClick={sendReuploadMail}
                                                                                    >
                                                                                        Upload Again
                                                                                    </button>
                                                                            }
                                                                            <ToastContainer />
                                                                        </div>
                                                                    }
                                                                </Popup>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            </div >
        </Fragment >
    )
}
export default AgentProfile